// src/App.tsx
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // 👈 change this
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import CarDetails from './pages/CarDetails';
import './App.css';
import AdminPage from './pages/Admin';
import AboutUs from './pages/AboutUs';
import GlossGarage from './pages/GlossGarage';
import ScrollToTop from './utils/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import SellCar from './pages/SellCar';


function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/car/:id" element={<CarDetails />} />
            <Route path="/adminSneha87603" element={<AdminPage />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/glossgarage" element={<GlossGarage />} />
            <Route path='/sellcar' element={<SellCar/>}/>
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;